// Helper function to generate fade animation props
export const getFadeProps = (duration = 0.6) => ({
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true },
    transition: { duration }
})

// Common animation functions for framer-motion
export const getFadeUpProps = (duration = 0.6, delay = 0) => ({
    initial: {
        opacity: 0,
        y: 20
    },
    whileInView: {
        opacity: 1,
        y: 0
    },
    viewport: { once: true },
    transition: {
        duration,
        ease: "easeOut",
        delay
    }
})

export const getFadeDownProps = (duration = 0.6) => ({
    initial: {
        opacity: 0,
        y: -20
    },
    whileInView: {
        opacity: 1,
        y: 0
    },
    viewport: { once: true },
    transition: {
        duration,
        ease: "easeOut"
    }
})

export const getFadeLeftProps = (duration = 0.6) => ({
    initial: {
        opacity: 0,
        x: -20
    },
    whileInView: {
        opacity: 1,
        x: 0
    },
    viewport: { once: true },
    transition: {
        duration,
        ease: "easeOut"
    }
})

export const getFadeRightProps = (duration = 0.6) => ({
    initial: {
        opacity: 0,
        x: 20
    },
    whileInView: {
        opacity: 1,
        x: 0
    },
    viewport: { once: true },
    transition: {
        duration,
        ease: "easeOut"
    }
})

export const getFadeInProps = (duration = 0.6) => ({
    initial: {
        opacity: 0
    },
    whileInView: {
        opacity: 1
    },
    viewport: { once: true },
    transition: {
        duration,
        ease: "easeOut"
    }
})

// For staggered children animations
export const getStaggerContainerProps = (staggerDuration = 0.1) => ({
    initial: { opacity: 0 },
    whileInView: {
        opacity: 1,
        transition: {
            staggerChildren: staggerDuration
        }
    },
    viewport: { once: true }
}) 